import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { map, tap } from "rxjs/operators";
import { saveAs } from "file-saver";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class JbpService {
    constructor(http) {
        this.http = http;
    }
    getItems(dto) {
        console.log(dto);
        return this.http.get(`${environment.api}/panel/joint-business/list`, {
            params: Object.assign({}, dto),
        });
    }
    getPlan(id) {
        return this.http
            .get(`${environment.api}/panel/joint-business/${id}/details`)
            .pipe(map((val) => {
            // val.status = 'period1';
            // val.status_comments[0] = {
            //   comment: 'sasa',
            //   status: 'started'
            // };
            // val.status_comments[1] = {
            //   comment: 'sasasasa',
            //   status: 'period1'
            // };
            // val.status_comments[2] = {
            //   comment: 'sasasasa',
            //   status: 'period2'
            // };
            return val;
        }));
    }
    getPriority() {
        return this.http.get(`${environment.api}/panel/joint-business/priority/dropdown`);
    }
    getStrategies(priorityId) {
        return this.http.get(`${environment.api}/panel/joint-business/priority/${priorityId}/strategies`);
    }
    getActions(priorityId) {
        return this.http.get(`${environment.api}/panel/joint-business/strategy/${priorityId}/actions`);
    }
    create(dto) {
        return this.http.post(`${environment.api}/panel/joint-business`, dto);
    }
    update(dto, id) {
        return this.http.post(`${environment.api}/panel/joint-business/${id}`, dto);
    }
    comment(id, comment) {
        return this.http.post(`${environment.api}/panel/joint-business/${id}/update-comment`, {
            comment,
        });
    }
    draft(id, draft) {
        console.warn(draft);
        return this.http.post(`${environment.api}/panel/joint-business/${id}/update-draft`, {
            comment: draft,
        });
    }
    export(data) {
        return this.http
            .get(`${environment.api}/panel/joint-business/export/xlsx`, {
            // @ts-ignore
            responseType: "blob",
        })
            .pipe(tap((res) => {
            const blobData = new Blob([res], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(blobData, `${data.filename}.xlsx`);
        }));
    }
    downloadPdf(id, clientName) {
        return this.http
            .get(`${environment.api}/panel/joint-business/${id}/download-plan`, {
            responseType: "blob",
        })
            .pipe(tap((res) => {
            const blobData = new Blob([res], { type: "application/pdf" });
            saveAs(blobData, `jbp.pdf`);
        }));
    }
}
JbpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function JbpService_Factory() { return new JbpService(i0.ɵɵinject(i1.HttpClient)); }, token: JbpService, providedIn: "root" });
